/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Players_Sort_ByInputs */



/**
* | output |
* | --- |
* | "Sort by" |
*
* @param {Players_Sort_ByInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const players_sort_by = /** @type {((inputs?: Players_Sort_ByInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Players_Sort_ByInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Trier par")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ordenar por")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ordenar por")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ordina per")
	return /** @type {LocalizedString} */ ("Sort by")
});